const ENGLISH = 'English (USA)';
const LANGUAGES = [
  { value: 0, label: 'Čeština', locale: 'cs' },
  { value: 1, label: 'Dansk', locale: 'da' },
  { value: 2, label: 'Deutsch', locale: 'de' },
  { value: 3, label: ENGLISH, locale: 'en' },
  { value: 4, label: 'Español', locale: 'es' },
  { value: 5, label: 'Français', locale: 'fr' },
  { value: 6, label: 'Italiano', locale: 'it' },
  { value: 7, label: '日本語', locale: 'ja' },
  { value: 8, label: '한국어', locale: 'ko' },
  { value: 9, label: 'Nederlands', locale: 'nl' },
  { value: 10, label: 'Norsk', locale: 'no' },
  { value: 11, label: 'Polski', locale: 'pl' },
  { value: 12, label: 'Português', locale: 'pt' },
  { value: 13, label: 'Русский', locale: 'ru' },
  { value: 14, label: 'Svenska', locale: 'sv' },
  { value: 15, label: 'Türkçe', locale: 'tr' },
  { value: 16, label: 'עברית', locale: 'he' },
  { value: 17, label: 'Tiếng Việt', locale: 'vi' },
];

export const getLocaleById = (val) => {
  return LANGUAGES[val] ? LANGUAGES[val].locale : 'en';
};

export const getLangOptions = () => {
  return LANGUAGES;
};

export const getDefaultLang = () => {
  const localeWix = window.Wix.Utils.getLocale() || 'en';
  return LANGUAGES.findIndex((lang) => lang.locale === localeWix);
};
